import { gql } from '@apollo/client';

import { AppMembershipFragment } from './appMemberships.fragment';

export * from './appMembershipsCreate.mutation.generated';

export const APP_MEMBERSHIP_CREATE = gql`
  mutation appMembershipsCreate($input: AppMembershipsCreateInput!) {
    appMembershipsCreate(input: $input) {
      errors
      success
      appMemberships {
        ...AppMembershipFragment
      }
    }
  }
  ${AppMembershipFragment}
`;
